import { appServiceApi } from "../../../app/appServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../types";

import {
  CheckUserBelongProjectDataType,
  CheckUserBelongProjectParamsType,
  GetAllPGAreaDataParamsType,
  GetAllPGAreaDataType,
  GetAllPGRegionDataType,
  GetAllPGTerritoriesDataParamsType,
  GetAllPGTerritoriesDataType,
  GetAllPGVendorDataType,
  GetAllProductDataParamsType,
  GetAllProductDataType,
  GetAllRoleDataParamsType,
  GetAllRoleDataType,
  GetAllUserListDataType,
  GetAllWorkFlowDataParamsType,
  GetAllWorkFlowDataType,
  GetProjectsByUserDataParamsType,
  GetProjectsByUserDataType,
  GetsingleParamsType,
  GetsingleProductDataType,
  GetsingleRoleDataType,
  GetUserListParams,
  GetUserPoolByWalletIdDataType,
  GetUserPoolByWalletIdParamsType,
  GetUserPoolProjectDataParamsType,
  GetUserPoolProjectDataType,
  GetUsersByProjectRoleDataParamsType,
  GetUsersByProjectRoleDataType,
  UserCompanyCountDataType,
  UserCompanyCountParamsType,
} from "../../../types/portal/product";

export const productsApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    createProduct: builder.mutation({
      query: (data) => ({
        url: API_URL.createProduct,
        method: "POST",
        body: data,
      }),
    }),

    getAllProduct: builder.query<
      GetAllProductDataType,
      GetQueryArgsType<GetAllProductDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllProduct,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllProduct"],
    }),

    userProduct: builder.query<
      GetAllProductDataType,
      GetQueryArgsType<GetAllProductDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.userProduct,
        params: queryArgs.params,
      }),
      providesTags: ["UserProduct"],
    }),

    getSingleProduct: builder.query<GetsingleProductDataType, string>({
      query: (id) => ({
        url: `${API_URL.getSingleProduct}/${id}`,
      }),
    }),

    updateProduct: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateProduct}/${id}/update-keycloak`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllProduct", "UserProduct"];
        return [];
      },
    }),

    createRole: builder.mutation({
      query: (data) => ({
        url: API_URL.createRole,
        method: "POST",
        body: data,
      }),
    }),

    getAllRole: builder.query<
      GetAllRoleDataType,
      GetQueryArgsType<GetAllRoleDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllRole,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllRole"],
    }),

    getSingleRole: builder.query<GetsingleRoleDataType, string>({
      query: (id) => ({
        url: `${API_URL.getSingleRole}/${id}`,
      }),
    }),

    assignUserToProjectRole: builder.mutation({
      query: (data) => ({
        url: API_URL.assignUserToProjectRole,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetProjectsByUser"];
        return [];
      },
    }),

    createUserPool: builder.mutation({
      query: (data) => ({
        url: API_URL.createUserPool,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetProjectsByUser", "GetUserPoolByWalletId"];
        return [];
      },
    }),

    getUserPoolByWalletId: builder.query<
      GetUserPoolByWalletIdDataType,
      GetQueryArgsType<GetUserPoolByWalletIdParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getUserPoolByWalletId,
        params: queryArgs.params,
      }),
      providesTags: ["GetUserPoolByWalletId"],
    }),

    getUsersByProjectRole: builder.query<
      GetUsersByProjectRoleDataType,
      GetQueryArgsType<GetUsersByProjectRoleDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getUsersByProjectRole,
        params: queryArgs.params,
      }),
      providesTags: ["GetUsersByProjectRole"],
    }),

    getProjectsByUser: builder.query<
      GetProjectsByUserDataType,
      GetQueryArgsType<GetProjectsByUserDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getProjectsByUser,
        params: queryArgs.params,
      }),
      providesTags: ["GetProjectsByUser"],
    }),

    createWorkFlow: builder.mutation({
      query: (data) => ({
        url: API_URL.createWorkFlow,
        method: "POST",
        body: data,
      }),
    }),

    getAllWorkFlow: builder.query<
      GetAllWorkFlowDataType,
      GetQueryArgsType<GetAllWorkFlowDataParamsType>
    >({
      query: ({ params }) => ({
        url: `${API_URL.getAllWorkFlow}/${params?.id}`,
        params: params,
      }),
      providesTags: (_, __, { params }) => [
        { type: "GetAllWorkFlow", id: params?.id },
      ],
    }),

    getSingleWorkFlow: builder.query<
      GetsingleRoleDataType,
      GetsingleParamsType
    >({
      query: ({ id }) => ({
        url: `${API_URL.getSingleWorkFlow}/${id}`,
      }),
      providesTags: ["GetSingleWorkFlow"],
    }),

    getUserPoolProject: builder.query<
      GetUserPoolProjectDataType,
      GetQueryArgsType<GetUserPoolProjectDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getUserPoolProject,
        params: queryArgs.params,
      }),
      providesTags: ["GetUserPoolProject"],
    }),

    updateWorkFlow: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateWorkFlow}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllWorkFlow", "GetSingleWorkFlow"];
        return [];
      },
    }),

    deleteUserPool: builder.mutation({
      query: ({ id }) => ({
        url: `${API_URL.deleteUserPool}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetProjectsByUser", "GetUserPoolByWalletId"];
        return [];
      },
    }),

    checkUserBelongProject: builder.query<
      CheckUserBelongProjectDataType,
      GetQueryArgsType<CheckUserBelongProjectParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.checkUserBelongProject,
        params: queryArgs.params,
      }),
      providesTags: ["CheckUserBelongProject"],
    }),

    userCompanyCount: builder.query<
      UserCompanyCountDataType,
      GetQueryArgsType<UserCompanyCountParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.userCompanyCount,
        params: queryArgs.params,
      }),
      providesTags: ["UserCompanyCount"],
    }),

    // Get User By Company Id and Project Id
    getUserList: builder.query<GetAllUserListDataType, GetUserListParams>({
      query: ({ page, limit, companyId, roleId, id, search }) => ({
        url: `${API_URL.getUserList}/${id}/users`,
        params: {
          page,
          limit,
          companyId,
          roleId,
          search,
        },
      }),

      providesTags: (_, __, arg) => [{ type: "GetUserList", id: arg.id }],
    }),

    userActiveInactiveRole: builder.mutation({
      query: (data) => ({
        url: `${API_URL.userActiveInactiveRole}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetProjectsByUser",
            "CheckUserBelongProject",
            "GetAllWorkFlow",
            "GetSingleWorkFlow",
            "GetUsersByProjectRole",
            "GetUserPoolProject",
            "GetUserPoolByWalletId",
            "GetUserList",
          ];
        return [];
      },
    }),

    getAllPGVendor: builder.query<GetAllPGVendorDataType, any>({
      query: () => ({
        url: `${API_URL.getAllPGVendor}`,
      }),
    }),

    getAllPGRegion: builder.query<GetAllPGRegionDataType, any>({
      query: () => ({
        url: `${API_URL.getAllPGRegion}`,
      }),
    }),

    getAllPGArea: builder.query<
      GetAllPGAreaDataType,
      GetQueryArgsType<GetAllPGAreaDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllPGArea,
        params: queryArgs.params,
      }),
    }),

    getAllPGTerritories: builder.query<
      GetAllPGTerritoriesDataType,
      GetQueryArgsType<GetAllPGTerritoriesDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllPGTerritories,
        params: queryArgs.params,
      }),
    }),

    deleteProductFeature: builder.mutation({
      query: ({ id, featureId }) => ({
        url: `${API_URL.updateProduct}/${id}/${featureId}/delete-feature`,
        method: "DELETE",
        // body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllProduct", "UserProduct"];
        return [];
      },
    }),
  }),
});

export const {
  useCreateProductMutation,
  useGetAllProductQuery,
  useUserProductQuery,
  useGetSingleProductQuery,
  useUpdateProductMutation,
  useCreateRoleMutation,
  useGetAllRoleQuery,
  useGetSingleRoleQuery,
  useAssignUserToProjectRoleMutation,
  useCreateUserPoolMutation,
  useGetUsersByProjectRoleQuery,
  useGetProjectsByUserQuery,
  useCreateWorkFlowMutation,
  useGetAllWorkFlowQuery,
  useGetSingleWorkFlowQuery,
  useGetUserPoolProjectQuery,
  useUpdateWorkFlowMutation,
  useDeleteUserPoolMutation,
  useLazyCheckUserBelongProjectQuery,
  useCheckUserBelongProjectQuery,
  useUserCompanyCountQuery,
  useUserActiveInactiveRoleMutation,
  useGetAllPGVendorQuery,
  useGetAllPGRegionQuery,
  useGetAllPGAreaQuery,
  useGetAllPGTerritoriesQuery,
  useDeleteProductFeatureMutation,
  useGetUserListQuery,
  useGetUserPoolByWalletIdQuery,
} = productsApi;
